module.exports = __webpack_public_path__ + "static/access_handbook_new_722x705-09c7f028535bdc822ff5c5c7bb49a647.webp";